import { format, parseISO } from "date-fns";
import { Locale } from "../schemas";

const formatDate = (created_at: string, language: Locale) => {
  const COMMENT_DATE_EN_FORMAT = "MM/dd/yyyy, hh:mm";
  const COMMENT_DATE_FR_FORMAT = "dd/MM/yyyy, hh:mm";

  return format(
    parseISO(created_at),
    language === "en" ? COMMENT_DATE_EN_FORMAT : COMMENT_DATE_FR_FORMAT
  );
};

export default formatDate;
